import { render } from "./ProjectPage.vue?vue&type=template&id=6411406e"
import script from "./ProjectPage.vue?vue&type=script&lang=js"
export * from "./ProjectPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/adrien/perso/Projets/new-portfolio/vuejs-tailwind-portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__